import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { companyService } from 'ogp/services';
import { ChangeCompanySettingsPayload } from 'ogp/services/company-service.types';

export const useUpdateCompanySettings = () => {
  const mutationFn = async (payload: ChangeCompanySettingsPayload) =>
    await companyService.updateCompanySettings(payload);
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => queryClient.invalidateQueries(QUERY_KEYS.companies()),
  });
};
